module.exports = __webpack_public_path__ + "img/book-7.42e969ba.png";